export default __webpack_public_path__ + "static/media/alert_info.d3ea045f.svg";